import { connect } from 'react-redux';
import { PartyForm } from 'vdlib';
import {
  clearCreateParty,
  clearUpdateParty,
  createParty,
  fetchParty,
  updateParty,
} from 'data/parties/Parties.actions';
import ReduxHelper from 'lib/ReduxHelper';

const mapStateToProps = (state, ownProps) =>
  ReduxHelper.mapStateWithLookups(
    {
      created: state.parties.partyCreated,
      defaultCountryID: state.app.userParty?.CountryID,
      userPartyTypeID: state.app.userParty?.PartyTypeID,
      fetching: state.parties.fetchingCurrentParty,
      lang: state.i18n.locale,
      party: state.parties.currentParty,
      partyAppMemberships: state.parties.partyAppMembershipsData,
      submitting: state.parties.creatingParty || state.parties.updatingParty,
    },
    state,
    'countries',
    'partyTypes',
    'regions',
    'taxOffices',
    'insurances',
    'applications',
    'memberships'
  );

const mapDispatchToProps = (dispatch, { router: { params } }) => {
  return {
    clear: () => {
      dispatch(clearCreateParty());
      dispatch(clearUpdateParty());
    },
    fetchParty: partyId => dispatch(fetchParty(partyId)),
    onSubmit: partyData =>
      dispatch(
        params && params.id
          ? updateParty({ ...partyData, ID: parseInt(params.id, 10) })
          : createParty(partyData)
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PartyForm);
